import { useMemo } from "react";
import useSessionPreferences from "src/store/useSessionPreferences";

interface IMainFilter {
  dateFrom: string;
  dateTo: string;
  clientProvider: string[];
  status: any;
  paymentMethod: any;
  tags: any;
  category: string[];
}

export default function useMainFilter() {
  const sessionMainFilter = useSessionPreferences((s) => s.filters.main);
  const setSessionPreferences = useSessionPreferences(
    (s) => s.setSessionPreferences,
  );

  const setMainFilter = (updates: any) => {
    setSessionPreferences({
      filters: {
        main: {
          ...updates,
        },
      },
    });
  };

  const isMainFilterActive = useMemo(() => {
    const {
      dateFrom,
      dateTo,
      clientProvider,
      status,
      paymentMethod,
      tags,
      category,
    } = sessionMainFilter;

    return !!(
      dateFrom ||
      dateTo ||
      clientProvider?.length ||
      status?.length ||
      paymentMethod?.length ||
      tags?.length ||
      category?.length
    );
  }, [sessionMainFilter]);

  return {
    mainFilter: sessionMainFilter,
    setMainFilter,
    isMainFilterActive,
  };
}
